<template>
    <div class="flex flex-col items-center justify-center w-full ">
        <wide-card>
            <div class="mt-4 ml-3 text-left">
                <label
                    class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                    >Avez-vous déjà créé votre entreprise?
                </label>
                <radio-box
                    label="Oui"
                    name="alreadyCreated"
                    :value="entreprise.isCreated"
                    @change="payload => (entreprise.isCreated = payload)"
                />
                <radio-box
                    class="ml-6"
                    label="Non"
                    name="alreadyCreated"
                    :value="entreprise.isCreated"
                    @change="payload => (entreprise.isCreated = payload)"
                />
            </div>
            <base-input
                placeholder="Dénomination sociale"
                v-model="entreprise.name"
                :hasError="$v.entreprise.name.$error"
                :errorMessage="
                    errorMessage('Dénomination sociale', $v.entreprise.name)
                "
                @blur="$v.entreprise.name.$touch()"
            />
            <select-menu
                label="Forme juridique"
                :option="FormeJuridiqueList"
                v-model="entreprise.legalForm"
                :hasError="$v.entreprise.legalForm.$error"
                :errorMessage="
                    errorMessage('Forme juridique', $v.entreprise.legalForm)
                "
            />

            <date-picker
                v-if="entreprise.isCreated === 'Oui'"
                :value="
                    entreprise.creationDate.seconds !== undefined
                        ? new Date(entreprise.creationDate.seconds * 1000)
                        : entreprise.creationDate
                "
                label="Date de création"
                v-on:setDate="payload => (entreprise.creationDate = payload)"
            />
            <base-input
                placeholder="Adresse du siège social"
                v-model="entreprise.Address"
                :hasError="$v.entreprise.Address.$error"
                :errorMessage="
                    errorMessage(
                        'Adresse du siège social',
                        $v.entreprise.Address
                    )
                "
                @blur="$v.entreprise.Address.$touch()"
            />
            <base-number-input
                :isCurrency="true"
                label="Capital social"
                v-model="entreprise.capitalSocial"
                :hasError="$v.entreprise.capitalSocial.$error"
                :errorMessage="
                    errorMessage('Capital social', $v.entreprise.capitalSocial)
                "
                @blur="$v.entreprise.capitalSocial.$touch()"
            />

            <div class="grid items-center grid-cols-1 gap-0 ">
                <div
                    v-for="(investor, index) in entreprise.partners"
                    :key="investor.key"
                    class="flex items-center justify-between py-4 my-3 overflow-hidden bg-gray-200 rounded-lg shadow"
                >
                    <div
                        class="flex-1 px-4 mr-8 font-bold text-left text-blue-600"
                    >
                        <base-input
                            placeholder=" Nom de l’associé"
                            Addclass="bg-gray-200"
                            v-model="investor.name"
                        />
                    </div>
                    <div class="flex items-center">
                        <h5 class="mr-3 text-gray-700">Gérant</h5>
                        <toggle
                            class="mr-6"
                            :triggered="investor.isManager"
                            @toggleTriggered="
                                payload => (investor.isManager = payload)
                            "
                        />
                        <div @click="removeInvestor(index)">
                            <base-icon
                                width="60"
                                height="60"
                                class="h-8"
                                icon-name="trash"
                                viewBox="0 0 20 20 "
                                iconColor="#6C98C6"
                            >
                                <icon-trash />
                            </base-icon>
                        </div>
                    </div>
                </div>
                <base-add-button
                    class="mx-auto"
                    title="Ajouter un associé"
                    @click="pushToArray"
                />
            </div>

            <div ref="sliders">
                <Slider
                    :items="entreprise.partners"
                    @onChange="calcPercentages"
                    ref="Partners"
                />
            </div>
        </wide-card>

        <base-primary-button title="Suivant" @click="createEntreprise" />
    </div>
</template>

<script>
import RadioBox from "@/components/forms/Toggles/radioBox";
import WideCard from "@/components/cards/wideCard";
import SelectMenu from "@/components/forms/select/selectMenu";
import DatePicker from "@/components/forms/DatePicker";
import Slider from "@/components/Slider.vue";
import Toggle from "@/components/forms/Toggles/simpleToggle";
import IconTrash from "@/components/icons/trash";

import { mapState } from "vuex";
import {
    required,
    decimal,
    minValue,
    minLength,
    maxLength
} from "vuelidate/lib/validators";
import { errorMessage } from "@/mixins/errorMessage.js";
import { scrollToError } from "@/mixins/scrollToMixin.js";

export default {
    components: {
        RadioBox,
        WideCard,
        Slider,
        SelectMenu,
        DatePicker,
        Toggle,
        IconTrash
    },

    mixins: [errorMessage, scrollToError],

    validations: {
        entreprise: {
            name: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(30)
            },
            legalForm: { required },
            Address: { minLength: minLength(3), maxLength: maxLength(250) },
            capitalSocial: { decimal, minValue: minValue(0) }
        }
    },

    data() {
        return {
            entreprise: {},
            sliderWidth: null
        };
    },
    computed: {
        ...mapState("forms", {
            FormeJuridiqueList: state => state.VotreProject.FormeJuridiqueList
        })
    },
    mounted() {
        this.sliderWidth = this.$refs.sliders.offsetWidth;
    },
    created() {
        this.entreprise = this.$store.getters["VotreProject/getEntreprise"];
        this.$store.dispatch(
            "forms/currentStepVotreProject",
            "Votre Entreprise"
        );
    },
    methods: {
        createEntreprise() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.$store.dispatch(
                    "VotreProject/createEntreprise",
                    this.entreprise
                );
                this.$store.dispatch("VotreProject/SaveEntreprise");
                this.$store.dispatch("forms/completStep", "Votre Entreprise");
                this.$router.push({
                    name: "_votre_projet",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
            } else {
                this.scrollToError();
                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        calcPercentages(payload) {
            payload.forEach((element, index) => {
                if (this.entreprise.partners[index] !== undefined)
                    this.entreprise.partners[index].percentage = element;
            });
        },
        refreshPartnersPercentage() {
            this.entreprise.partners.forEach(elem => {
                elem.percentage = Math.floor(
                    100 / this.entreprise.partners.length
                );
            });

            let total = this.entreprise.partners.reduce((a, b) => {
                return a + b.percentage;
            }, 0);

            if (total !== 100) {
                let rest = 100 - total;
                this.entreprise.partners[
                    this.entreprise.partners.length - 1
                ].percentage += rest;
            }
        },
        pushToArray() {
            this.entreprise.partners.push({
                name: "",
                color: [],
                percentage: null,
                isManager: false,
                key: new Date().getTime()
            });
            this.refreshPartnersPercentage();
        },
        removeInvestor(index) {
            this.entreprise.partners.splice(index, 1);
            this.refreshPartnersPercentage();
        }
    }
};
</script>

<style></style>
